import React from 'react';
import PropTypes from 'prop-types';
import {
  useTheme, Zoom, Fab, makeStyles,
} from '@material-ui/core';
import { seedCRUDFCreateFabIcons } from '../../../icon/seed-icons';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

const CRUDFCreateFab = ({ path, icons }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Zoom
      in
      timeout={{
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
      }}
    >
      <Fab
        color="secondary"
        className={classes.fab}
        href={path}
      >
        <icons.Add />
      </Fab>
    </Zoom>
  );
};

CRUDFCreateFab.propTypes = {
  path: PropTypes.string.isRequired,
  icons: PropTypes.shape({
    Add: PropTypes.object.isRequired,
  }),
};

CRUDFCreateFab.defaultProps = {
  icons: seedCRUDFCreateFabIcons,
};


export default CRUDFCreateFab;
